import { useGetShippingsListQuery } from '../services';
import { ShippingsFilter } from '../models';

interface UseShippingsProps {
  filters: ShippingsFilter;
  page: number;
  pageSize: number;
}

const useShippings = ({ filters, page, pageSize }: UseShippingsProps) => {
  const {
    data: shippingsData,
    isLoading: isShippingsLoading,
    isFetching: isShippingsFetching,
    error: shippingsError,
    refetch: refetchShippings,
  } = useGetShippingsListQuery(
    {
      paginated: {
        page,
        pageSize,
      },
      filters,
    },
    { refetchOnMountOrArgChange: true }
  );

  return {
    shippings: shippingsData?.items || [],
    totalItems: shippingsData?.count || 0,
    totalPages: shippingsData?.count
      ? Math.ceil(shippingsData.count / pageSize)
      : 0,
    isShippingsLoading,
    isShippingsFetching,
    shippingsError,
    refetchShippings,
  };
};

export default useShippings;
